import { render, staticRenderFns } from "./PruningReasons.vue?vue&type=template&id=687e874a"
import script from "./PruningReasons.vue?vue&type=script&lang=js"
export * from "./PruningReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports